import { DotsFilledIcon } from '@approvalmax/ui';
import { Button, Dropdown, Menu, MenuItemProps } from '@approvalmax/ui/src/components';
import { domHelpers } from '@approvalmax/utils';
import { useSetAtom } from 'jotai';
import { memo, useCallback, useMemo } from 'react';

import { fundWalletPopupState } from '../../../FundWalletPopup/FundWalletPopup.states';
import { messages } from './CardControls.messages';
import { CardControlsProps } from './CardControls.types';

const qa = 'wallet-card-controls';

export const CardControls = memo<CardControlsProps>((props) => {
    const { currencyCode, wallet } = props;

    const emptyHandler = useCallback(() => {}, []);

    const setFundWalletPopup = useSetAtom(fundWalletPopupState);

    const openFundWalletPopup = useCallback(() => {
        setFundWalletPopup({ currencyCode, walletId: wallet.id });
    }, [currencyCode, wallet.id, setFundWalletPopup]);

    const items = useMemo<MenuItemProps[]>(
        () => [
            {
                name: messages.details,
                onClick: emptyHandler,
            },
            {
                name: messages.fund,
                onClick: openFundWalletPopup,
                disabled: !wallet.isFundable,
            },
            {
                name: messages.transactions,
                onClick: emptyHandler,
            },
            {
                name: messages.hide,
                onClick: emptyHandler,
            },
        ],
        [emptyHandler, openFundWalletPopup, wallet]
    );

    return (
        <>
            <Dropdown
                closeOnClickInnerButton
                width='max-content'
                activator={
                    <Button
                        icon
                        noPadding
                        data-qa={domHelpers.generateDataQa(qa, 'menu-button')}
                        variant='text'
                        color='blue100'
                    >
                        <DotsFilledIcon />
                    </Button>
                }
            >
                <Menu items={items} />
            </Dropdown>
        </>
    );
});

CardControls.displayName = 'CardControls';
